import loadable from '@wix/yoshi-flow-editor/loadable';

export const MyGroups = loadable(
  () => import(/* webpackChunkName: "MyGroups" */ './MyGroups'),
  {
    resolveComponent: (component) => component.MyGroups,
  },
);
